"use strict";

module.exports = {
  'name': 'leftShift',
  'category': 'Bitwise',
  'syntax': ['x << y', 'leftShift(x, y)'],
  'description': 'Bitwise left logical shift of a value x by y number of bits.',
  'examples': ['4 << 1', '8 >> 1'],
  'seealso': ['bitAnd', 'bitNot', 'bitOr', 'bitXor', 'rightArithShift', 'rightLogShift']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/bitwise/leftShift.js
// module id = 864
// module chunks = 0